function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function(key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null)
    return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
import { getCommonParams } from "./perf-tracker/utils";
const DEFAULT_JS_ERROR_CONFIG = {
  pageCrash: false,
  cuj: false
};
class TrackingContext {
  constructor() {
    this.slardarWindowGlobalName = "";
    this.slardarHybridGlobalName = "";
    this._shouldReportJSError = {
      pageCrash: false,
      cuj: false
    };
    this.setContext = (context) => {
      this._context = context;
    };
    this.initSlardar = (arg) => {
      try {
        const { slardarContainer, slardarWindowGlobalName, slardarHybridGlobalName, sparkMonitor, reportActualFMP, shouldReportJSError } = arg !== null && arg !== void 0 ? arg : {};
        if (typeof slardarWindowGlobalName === "string") {
          this.slardarWindowGlobalName = slardarWindowGlobalName;
        }
        if (typeof slardarHybridGlobalName === "string") {
          this.slardarHybridGlobalName = slardarHybridGlobalName;
        }
        if (typeof reportActualFMP === "function") {
          this.reportTTAPActualFMP = reportActualFMP;
        }
        if (typeof sparkMonitor !== "undefined") {
          this.sparkMonitor = sparkMonitor;
        }
        if (typeof slardarContainer !== "undefined" && typeof slardarContainer.sendEvent === "function" && typeof slardarContainer.reportActualFMP === "function") {
          this.slardarContainer = slardarContainer;
        }
        this._shouldReportJSError = _object_spread({}, DEFAULT_JS_ERROR_CONFIG, shouldReportJSError !== null && shouldReportJSError !== void 0 ? shouldReportJSError : {});
      } catch (e) {
      }
    };
    this.initJSB = (jsbBridge) => {
      this.jsbBridge = jsbBridge;
    };
    this._formatEventPayload = (payload) => {
      const { name, metrics, categories } = payload, rest = _object_without_properties(payload, [
        "name",
        "metrics",
        "categories"
      ]);
      const categoriesWithContext = _object_spread({}, categories, this._context);
      return _object_spread({
        name,
        metrics,
        categories: categoriesWithContext
      }, rest);
    };
    this._formatErrorPayload = (payload) => {
      return _object_spread({}, payload !== null && payload !== void 0 ? payload : {}, this._context);
    };
    this.sendEvent = (payload) => {
      try {
        var _window, _window1;
        var _this__formatEventPayload;
        const formattedPayload = (_this__formatEventPayload = this._formatEventPayload(payload)) !== null && _this__formatEventPayload !== void 0 ? _this__formatEventPayload : {};
        if (this.slardarWindowGlobalName && typeof ((_window = window) === null || _window === void 0 ? void 0 : _window[this.slardarWindowGlobalName]) === "function") {
          window[this.slardarWindowGlobalName]("sendEvent", formattedPayload);
        }
        if (this.slardarHybridGlobalName && typeof ((_window1 = window) === null || _window1 === void 0 ? void 0 : _window1[this.slardarHybridGlobalName]) === "function") {
          const { name = "", categories } = formattedPayload, rest = _object_without_properties(formattedPayload, [
            "name",
            "categories"
          ]);
          window[this.slardarHybridGlobalName]("emit", "custom", _object_spread({
            eventName: name,
            level: 0,
            category: categories
          }, rest));
        }
        if (this.slardarContainer) {
          this.slardarContainer.sendEvent(formattedPayload);
        }
      } catch (e) {
      }
    };
    this._sendError = (error, payload) => {
      if (this._shouldReportJSError) {
        try {
          var _window, _window1;
          var _this__formatErrorPayload;
          const formattedPayload = (_this__formatErrorPayload = this._formatErrorPayload(payload)) !== null && _this__formatErrorPayload !== void 0 ? _this__formatErrorPayload : {};
          if (this.slardarWindowGlobalName && typeof ((_window = window) === null || _window === void 0 ? void 0 : _window[this.slardarWindowGlobalName]) === "function") {
            window[this.slardarWindowGlobalName]("captureException", error, formattedPayload);
          }
          if (this.slardarHybridGlobalName && typeof ((_window1 = window) === null || _window1 === void 0 ? void 0 : _window1[this.slardarHybridGlobalName]) === "function") {
            const { name = "" } = formattedPayload, rest = _object_without_properties(formattedPayload, [
              "name"
            ]);
            window[this.slardarHybridGlobalName]("captureException", error, _object_spread({
              eventName: name,
              level: 0
            }, rest));
          }
          if (this.slardarContainer && typeof this.slardarContainer.captureException === "function") {
            this.slardarContainer.captureException(error, formattedPayload);
          }
        } catch (e) {
        }
      }
    };
    this.sendPageCrashError = (error, payload) => {
      if (this._shouldReportJSError.pageCrash) {
        this._sendError(error, payload);
      }
    };
    this.sendCUJError = (error, payload) => {
      if (this._shouldReportJSError.cuj) {
        this._sendError(error, payload);
      }
    };
    this.teaReport = (payload) => {
      var _window;
      var _this__formatEventPayload;
      const formattedPayload = (_this__formatEventPayload = this._formatEventPayload(payload)) !== null && _this__formatEventPayload !== void 0 ? _this__formatEventPayload : {};
      if (typeof window !== "undefined" && typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.collectEvent) === "function") {
        var _window1;
        (_window1 = window) === null || _window1 === void 0 ? void 0 : _window1.collectEvent(formattedPayload.name, _object_spread({}, formattedPayload.metrics, formattedPayload.categories, getCommonParams()));
      }
      if (this.jsbBridge) {
        void this.jsbBridge.x.reportAppLog({
          eventName: formattedPayload.name,
          params: _object_spread({}, formattedPayload.metrics, formattedPayload.categories, getCommonParams())
        });
      }
    };
    this.resetTeaModule = () => {
      this.jsbBridge = void 0;
    };
    this.resetSlardarModule = () => {
      this.slardarContainer = void 0;
      this.slardarWindowGlobalName = "";
      this.slardarHybridGlobalName = "";
      this.sparkMonitor = void 0;
      this.reportTTAPActualFMP = void 0;
    };
  }
}
export {
  TrackingContext
};
